import { render, staticRenderFns } from "./SoftwareQualityAttributes.vue?vue&type=template&id=a090b536&scoped=true&"
import script from "./SoftwareQualityAttributes.vue?vue&type=script&lang=js&"
export * from "./SoftwareQualityAttributes.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareQualityAttributes.vue?vue&type=style&index=0&id=a090b536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a090b536",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardTitle,VCheckbox,VIcon,VTooltip})
